var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-row',[_c('rkm-col',{attrs:{"cols":"12"}},[_c('rkm-form-checkbox',{model:{value:(_vm.data.model.exibirReagendarExame),callback:function ($$v) {_vm.$set(_vm.data.model, "exibirReagendarExame", $$v)},expression:"data.model.exibirReagendarExame"}},[_vm._v(" Se ativo, exibirá a mensagem para reagendar os exames não coletados. ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }